import { render, staticRenderFns } from "./Dropbox.vue?vue&type=template&id=5b0ee6e4"
import script from "./Dropbox.vue?vue&type=script&lang=js"
export * from "./Dropbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports